export default "__VITE_ASSET__CL7p2G8M__"